import { render, staticRenderFns } from "./DownloadModal.vue?vue&type=template&id=67303f9c&scoped=true"
import script from "./DownloadModal.vue?vue&type=script&lang=js"
export * from "./DownloadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67303f9c",
  null
  
)

export default component.exports